const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { createPreventDefault } from '../../utilities/general';
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

let els = {};
const elsMap = {
    detailsDimName: "#dtls-dim-name",
    editDimBtn: ".dtls-edit-btn"
}
const elsModal = {};
const elsModalMap = {};
const targetSelector = "#dimdivisor-details";

run(targetSelector, (mainEl) => {
    let targetObject = "";
    let deActivateDimModal = null;
    const dimDivisorDetailsJson = mainEl.data("dimdivisor-details-json");
    const activateDimBtn = mainEl.find(".activate-dim-divisor");
    const deactivateDimBtn = mainEl.find(".deactivate-dim-divisor");
    const changeDimStatusUrl = mainEl.data("change-status-url");
    const pageReloadUrl = mainEl.data("detail-page-reload-url");
    const editDimDivisorUrl = mainEl.data("edit-dim-divisor-url");
    const portletNamespace = mainEl.data("portlet-namespace");
  
    
    function init() {
        setElementsInModals();
        setElements();
        bindElements();
        loadDataOnUI();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function setElementsInModals() {
        const body = $('body');
        setElementsFromScope(elsModal, elsModalMap, body);
    }

    function bindElements() {
        
        deactivateDimBtn.on("click", function(e){
            e.preventDefault();
            deActivateDimModal = new SubmitModalFlow({
            confirmModalTitle: 'Deactivate Dim Divisor',
            confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this dim divisor will no longer be available for selected merchants. This dim divisor can be reactivated at any time.</div>`,
            confirmModalBtnText: 'Deactivate Dim Divisor',
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function(){
                deActivateDimModal.showLoadingModal();
                handleDimActivateDeactivate({url: changeDimStatusUrl, input: 'N' , success:deactiveDimSuccess, error: deactiveDimError});
            }
            });
            deActivateDimModal.init();
            deActivateDimModal.showConfirmModal();
        });

        activateDimBtn.on("click", function(e){
            e.preventDefault();
            deActivateDimModal = new SubmitModalFlow({
            confirmModalTitle: 'Activate Dim Divisor',
            confirmModalBody: `<div class="q-pad-all-xl">Once activated, this dim divisor will be available for selected merchants. This dim divisor can be deactivated at any time.</div>`,
            confirmModalBtnText: 'Activate Dim Divisor',
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function(){
                deActivateDimModal.showLoadingModal();
                handleDimActivateDeactivate({url: changeDimStatusUrl, input: 'Y' , success:deactiveDimSuccess, error: deactiveDimError});
            }
            });
            deActivateDimModal.init();
            deActivateDimModal.showConfirmModal();
        });
        els.editDimBtn.click(createPreventDefault(editDimDivisor));
        
    }

    function loadDataOnUI(){
        let serviceValues = [];
        let dimDivisorInfoJson = dimDivisorDetailsJson.dimDivisorInfo;
        serviceValues = dimDivisorInfoJson.usServiceLevels;
        loadServiceValues(serviceValues);
        serviceValues = dimDivisorInfoJson.canadaServiceLevels;
        loadServiceValues(serviceValues);
        serviceValues = dimDivisorInfoJson.otherServiceLevels;
        loadServiceValues(serviceValues);
    }

    function loadServiceValues(serviceValues){
        _.each(serviceValues, (el)=>{
           const id= "#"+el.dmdShipmentMethodId;
           $(id).text(el.dmdDimValue);
          });
    }

    function deactiveDimSuccess(data){    
        if(data.responseStatus === "Success"){
			const detailUrlFullURL = pageReloadUrl;
			deActivateDimModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deActivateDimModal.showFailureModal();
		}
    }
    function editDimDivisor() {
        window.location.href = editDimDivisorUrl+'&'+ portletNamespace+ 'dimId='+ dimDivisorDetailsJson.dimDivisorInfo.dimId +'&'+portletNamespace +'flow=edit';
    };
    
    function handleDimActivateDeactivate({url, input, success, error}){    
		$.ajax({
			url: url,
			data:{"dimStatus" : input},
			dataType:"JSON",
			type: 'POST',
			success: success,
			error: error
    });    
  }

  function deactiveDimError(){
    deActivateDimModal.hideAllModals();
}

    init();
  
}); 


// WEBPACK FOOTER //
// ./src/pages/dimdivisor/dimDivisorDetails.js